export default __webpack_public_path__ + "static/media/bhxh-explain.cffbd6a9.jpg";